import {
	Button,
	Icon,
	Tooltip
} from '@patternfly/react-core';
import { TrashIcon } from '@patternfly/react-icons';
import React from 'react';
import { RemoveConfirmModal } from '@app/components/RemoveConfirmModal';

export interface RemoveButton {
  /** Callback function to remove */
  onRemoveConfirm(event: KeyboardEvent | React.MouseEvent): void;
  /** confirmation message */
  confirmationMessage?: string;
  /** modal title */
  modalTitle?: string;
  /** is active flag */
  isDisabled?: boolean;

  id?: string;
}

export const RemoveButton: React.FunctionComponent<RemoveButton> = ({
  confirmationMessage = "Confirm removal?",
  modalTitle = "Confirm removal?",
  isDisabled = false,
  ...props
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const toogle = (_event: KeyboardEvent | React.MouseEvent) => {
    setIsModalOpen(!isModalOpen);
  }

  const onRemoveClick = (_event: KeyboardEvent | React.MouseEvent) => {
    toogle(_event);
  }

  const onConfirmRemove = (_event: KeyboardEvent | React.MouseEvent) => {
    props.onRemoveConfirm(_event);
    toogle(_event);
  }

  const onCancelRemove = (_event: KeyboardEvent | React.MouseEvent) => {
    toogle(_event);
  }

  return (
    <React.Fragment>
      <Tooltip content="Remove">
        <Button icon={<Icon size='lg'><TrashIcon/></Icon>}
          variant="plain" id="remove-button" onClick={onRemoveClick} isDisabled={isDisabled} />
      </Tooltip>
      <RemoveConfirmModal isOpen={isModalOpen} modalTitle={modalTitle} confirmationMessage={confirmationMessage}
        onRemoveConfirm={onConfirmRemove} onRemoveCancel={onCancelRemove} />
    </React.Fragment>
  );
};